module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/simple-table/simple-table.component.css
// module id = ./src/app/components/shared/simple-table/simple-table.component.css
// module chunks = main